import { ProductListResponseType } from "@sellar-io/api-v2/types";

import { createContext, useContext } from "react";

import { OrderOnBehalfOfOrderItemType } from "../OrderOnBehalfOf.shared";

export type ContainerFilter = (typeof containerFilterList)[number];

export type StatusFilter = (typeof statusFilterList)[number];

export enum AddToOrderDialogPage {
  PRODUCT_LIST,
  PRODUCT_ITEM,
}

export const AddToOrderDialogContext = createContext<
  | {
      searchQuery: string;
      setSearchQuery: (searchQuery: string) => void;
      selectedStatusFilters: StatusFilter[];
      setSelectedStatusFilters: (selectedStatusFilters: StatusFilter[]) => void;
      selectedContainerFilters: ContainerFilter[];
      setSelectedContainerFilters: (ContainerFilter: ContainerFilter[]) => void;
      productItem?: ProductListResponseType[number];
      setProductItem: (
        product: ProductListResponseType[number] | undefined,
      ) => void;
      onSubmit: (product: OrderOnBehalfOfOrderItemType) => void;
    }
  | undefined
>(undefined);

export const useAddToOrderDialogContext = () => {
  const context = useContext(AddToOrderDialogContext);
  if (context === undefined) {
    throw new Error(
      "useAddToOrderDialogContext must be within AddToOrderDialogContextProvider",
    );
  }

  return context;
};

export const containerFilterList = [
  "Keg",
  "Cask",
  "Can",
  "Bottle",
  "Bag In Box",
] as const;

export const statusFilterList = ["Active only", "In stock"] as const;

export const containerNameAsValue = (name: ContainerFilter) => {
  switch (name) {
    case "Bag In Box":
      return "bagInBox";
    case "Can":
      return "can";
    case "Bottle":
      return "bottle";
    case "Cask":
      return "cask";
    case "Keg":
      return "keg";
  }
};
